import React, {Component} from 'react';
import connect from "react-redux";
// import MainComponent from "./components/main-component"
import LegaxCalculator from "./components/legax-calculator"
import './App.css';

class App extends Component {
    constructor(props) {
        super(props);
        this.state={

       }
    }

    render() {
        return (
            <div className="App" {...this.props}>
                <LegaxCalculator {...this.props}/>
            </div>
        );
    }
}




export default App;
